"use client";
import { useEffect, useState } from "react";
import { Icon } from "./icons";

type Deal = {
  id: string;
  title: string;
  amount: string;
  stage_name: string;
  company_name: string;
  contact_name?: string;
  garment_type?: string;
  workflow?: string;
  work_description?: string;
  payment_status?: string;
  fitting_at?: string;
  ready_at?: string;
  collection_at?: string;
  master_name?: string;
};
type Client = { id: string; name: string };
type Stage = { id: string; name: string };
const stages = {
  tailoring: ["Заказ в очереди", "Снятие мерок", "Примерка", "Пошив", "Готово к выдаче"],
  repair: ["Заказ в очереди", "Диагностика", "Согласование", "Ремонт", "Готово к выдаче"],
};

export function PipelineLiveView() {
  const [deals, setDeals] = useState<Deal[]>([]);
  const [loading, setLoading] = useState(true);
  const [workflow, setWorkflow] = useState<keyof typeof stages>("tailoring");
  const [selected, setSelected] = useState<Deal | null>(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    title: "",
    garmentType: "",
    workDescription: "",
    amount: "",
    fittingAt: "",
    readyAt: "",
    collectionAt: "",
    clientId: "",
    stageId: "",
  });
  const [clients, setClients] = useState<Client[]>([]);
  const [availableStages, setAvailableStages] = useState<Stage[]>([]);
  const [message, setMessage] = useState("");
  useEffect(() => {
    Promise.all([fetch("/api/deals"), fetch("/api/clients"), fetch("/api/stages")])
      .then(async ([dealsResponse, clientsResponse, stagesResponse]) => {
        const dealData = dealsResponse.ok
          ? await dealsResponse.json()
          : { deals: [], error: "Схема ателье ещё не подключена." };
        const clientData = clientsResponse.ok ? await clientsResponse.json() : { clients: [] };
        const stageData = stagesResponse.ok ? await stagesResponse.json() : { stages: [] };
        setDeals(dealData.deals);
        setClients(clientData.clients);
        setAvailableStages(stageData.stages);
        if (dealData.error) setMessage(dealData.error);
      })
      .finally(() => setLoading(false));
  }, []);
  return (
    <section className="module-view" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:64:5"}>
      <div className="module-heading" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:65:7"}>
        <div data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:66:9"}>
          <div className="breadcrumb" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:67:11"}>
            Рабочее пространство <span data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:68:34"}>/</span> Заказы
          </div>
          <h1 data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:70:11"}>Заказы в работе</h1>
          <p data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:71:11"}>{deals.length} заказов в вашем доступе · пошив и ремонт</p>
        </div>
        <button
          className="primary-button"
          onClick={() => {
            setSelected(null);
            setEditing(true);
            setForm({
              title: "",
              garmentType: "",
              workDescription: "",
              amount: "",
              fittingAt: "",
              readyAt: "",
              collectionAt: "",
              clientId: clients[0]?.id ?? "",
              stageId:
                availableStages.find((stage) => stage.name === "Заказ в очереди")?.id ??
                availableStages[0]?.id ??
                "",
            });
          }}
         data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:73:9"}>
          <Icon name="plus" size={16} data-amazi-jsx-id={"crm/src/features/crm/pipeline-live-view.tsx:94:11"} /> Новый заказ
        </button>
      </div>
      <div className="pipeline-toolbar" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:97:7"}>
        <div className="view-tabs" aria-label="Тип заказа" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:98:9"}>
          <button
            className={workflow === "tailoring" ? "selected" : ""}
            onClick={() => setWorkflow("tailoring")}
           data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:99:11"}>
            Пошив
          </button>
          <button
            className={workflow === "repair" ? "selected" : ""}
            onClick={() => setWorkflow("repair")}
           data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:105:11"}>
            Ремонт
          </button>
        </div>
        <span className="pipeline-note" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:112:9"}>Сроки, примерки и корректировки в одной очереди</span>
      </div>
      <div className="pipeline-board" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:114:7"}>
        {loading ? (
          <div className="empty-message" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:116:11"}>Загружаем заказы и этапы…</div>
        ) : (
          stages[workflow].map((stage) => {
            const stageDeals = deals.filter((deal) => deal.stage_name === stage);
            return (
              <div className="order-stage" key={stage} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:121:15"}>
                <div className="stage-head" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:122:17"}>
                  <h3 data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:123:19"}>
                    <i className="stage-dot blue" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:124:21"} />
                    {stage}
                  </h3>
                  <span data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:127:19"}>{stageDeals.length}</span>
                </div>
                {stageDeals.map((deal) => (
                  <button className="deal-card" key={deal.id} onClick={() => setSelected(deal)} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:130:19"}>
                    <div className="deal-logo" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:131:21"}>✂</div>
                    <div data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:132:21"}>
                      <strong data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:133:23"}>{deal.title}</strong>
                      <span data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:134:23"}>
                        {deal.company_name} · {deal.garment_type ?? "Изделие"}
                      </span>
                    </div>
                    <b data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:138:21"}>₽ {deal.amount}</b>
                  </button>
                ))}
                {stageDeals.length === 0 && <p className="stage-empty" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:141:45"}>Заказов пока нет</p>}
              </div>
            );
          })
        )}
      </div>
      {message && (
        <div className="form-error" role="alert" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:148:9"}>
          {message}
        </div>
      )}
      {(editing || selected) && (
        <div className="panel order-detail" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:153:9"}>
          <button
            className="close-detail"
            onClick={() => {
              setEditing(false);
              setSelected(null);
            }}
           data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:154:11"}>
            ×
          </button>
          {selected && !editing ? (
            <>
              <h2 data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:165:15"}>{selected.title}</h2>
              <p data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:166:15"}>
                {selected.company_name} · {selected.contact_name ?? "Контакт не указан"}
              </p>
              <dl data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:169:15"}>
                <div data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:170:17"}>
                  <dt data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:171:19"}>Изделие и работа</dt>
                  <dd data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:172:19"}>
                    {selected.garment_type ?? "—"} ·{" "}
                    {selected.work_description ?? "Уточнение не добавлено"}
                  </dd>
                </div>
                <div data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:177:17"}>
                  <dt data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:178:19"}>Мастер</dt>
                  <dd data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:179:19"}>{selected.master_name ?? "Не назначен"}</dd>
                </div>
                <div data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:181:17"}>
                  <dt data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:182:19"}>Примерка / готовность / выдача</dt>
                  <dd data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:183:19"}>
                    {[selected.fitting_at, selected.ready_at, selected.collection_at]
                      .map((date) => (date ? new Date(date).toLocaleDateString("ru-RU") : "—"))
                      .join(" · ")}
                  </dd>
                </div>
              </dl>
              <button
                className="outline-button"
                onClick={() => {
                  setEditing(true);
                  setForm({
                    title: selected.title,
                    garmentType: selected.garment_type ?? "",
                    workDescription: selected.work_description ?? "",
                    amount: selected.amount,
                    fittingAt: selected.fitting_at?.slice(0, 16) ?? "",
                    readyAt: selected.ready_at?.slice(0, 16) ?? "",
                    collectionAt: selected.collection_at?.slice(0, 16) ?? "",
                    clientId: "",
                    stageId:
                      availableStages.find((stage) => stage.name === selected.stage_name)?.id ?? "",
                  });
                }}
               data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:190:15"}>
                Изменить заказ
              </button>
              <h3 className="history-title" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:210:15"}>История корректировок</h3>
              <p className="stage-empty" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:211:15"}>
                Комментарии и изменения доступны после подключения схемы ателье.
              </p>
            </>
          ) : (
            <form
              className="create-form"
              onSubmit={async (event) => {
                event.preventDefault();
                const response = await fetch(
                  selected ? `/api/deals/${selected.id}` : "/api/deals",
                  {
                    method: selected ? "PATCH" : "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...form, workflow, amount: Number(form.amount || 0) }),
                  },
                );
                const data = await response.json();
                if (!response.ok) {
                  setMessage(data.error ?? "Не удалось сохранить заказ");
                  return;
                }
                setMessage("Заказ сохранён.");
                setEditing(false);
                setSelected(null);
              }}
             data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:216:13"}>
              <h2 data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:238:15"}>{selected ? "Изменить заказ" : "Новый заказ"}</h2>
              <>
                {!selected && (
                  <>
                    <select
                      required
                      value={form.clientId}
                      onChange={(e) => setForm({ ...form, clientId: e.target.value })}
                     data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:242:21"}>
                      <option value="" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:247:23"}>Выберите клиента</option>
                      {clients.map((client) => (
                        <option key={client.id} value={client.id} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:249:25"}>
                          {client.name}
                        </option>
                      ))}
                    </select>
                    <select
                      required
                      value={form.stageId}
                      onChange={(e) => setForm({ ...form, stageId: e.target.value })}
                     data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:254:21"}>
                      <option value="" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:259:23"}>Выберите этап</option>
                      {availableStages.map((stage) => (
                        <option key={stage.id} value={stage.id} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:261:25"}>
                          {stage.name}
                        </option>
                      ))}
                    </select>
                  </>
                )}
                {selected && (
                  <select
                    value={form.stageId}
                    onChange={(e) => setForm({ ...form, stageId: e.target.value })}
                   data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:269:19"}>
                    <option value="" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:273:21"}>Этап не изменять</option>
                    {availableStages.map((stage) => (
                      <option key={stage.id} value={stage.id} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:275:23"}>
                        {stage.name}
                      </option>
                    ))}
                  </select>
                )}
              </>
              <input
                required
                placeholder="Название заказа"
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:282:15"}
              />
              <input
                placeholder="Изделие (например, пальто)"
                value={form.garmentType}
                onChange={(e) => setForm({ ...form, garmentType: e.target.value })} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:288:15"}
              />
              <textarea
                placeholder="Описание работы и уточнения"
                value={form.workDescription}
                onChange={(e) => setForm({ ...form, workDescription: e.target.value })} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:293:15"}
              />
              <input
                type="number"
                placeholder="Стоимость, ₽"
                value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:298:15"}
              />
              <label data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:304:15"}>
                Дата примерки
                <input
                  type="datetime-local"
                  value={form.fittingAt}
                  onChange={(e) => setForm({ ...form, fittingAt: e.target.value })} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:306:17"}
                />
              </label>
              <label data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:312:15"}>
                Готовность
                <input
                  type="datetime-local"
                  value={form.readyAt}
                  onChange={(e) => setForm({ ...form, readyAt: e.target.value })} data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:314:17"}
                />
              </label>
              <button className="primary-button" data-amazi-id={"crm/src/features/crm/pipeline-live-view.tsx:320:15"}>Сохранить заказ</button>
            </form>
          )}
        </div>
      )}
    </section>
  );
}
